import { useState, useEffect, useRef } from 'react';
import '../styles/facilities.css';

interface Facility {
  id: number;
  name: string;
  description: string;
  icon: React.ReactNode;
  bgColor: string;
}

const facilities: Facility[] = [
  {
    id: 1,
    name: 'Khuôn viên 31 hecta',
    description: 'Khuôn viên rộng lớn với 8 tòa nhà hiện đại',
    icon: '/images/ctump/1.jpg',
    bgColor: '#0d7a3c'
  },
  {
    id: 2,
    name: 'Phòng thí nghiệm hiện đại',
    description: 'Trang thiết bị tiên tiến, đạt chuẩn quốc tế',
    icon: '/images/ctump/2.jpg',
    bgColor: '#2cb65d'
  },
  {
    id: 3,
    name: 'Bệnh viện đơn vị',
    description: '18 bệnh viện thực hành liên kết',
    icon: '/images/ctump/3.jpg',
    bgColor: '#05502a'
  },
  {
    id: 4,
    name: 'Thư viện hiện đại',
    description: 'Thư viện số và tài liệu khảo cứu đầy đủ',
    icon: '/images/ctump/4.jpg',
    bgColor: '#00a651'
  },
  {
    id: 5,
    name: 'Khu sinh viên',
    description: 'Ký túc xá, quán ăn, khu thể thao hoàn chỉnh',
    icon: '/images/ctump/6.jpg',
    bgColor: '#0d7a3c'
  },
];

export default function Facilities() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % facilities.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="facilities section" id="facilities" ref={sectionRef}>
      <div className="container">
        <h2 className="section-title fade-up">Cơ sở vật chất</h2>

        <div className="facilities-content">
          <div className="facilities-slider">
            <div className="slider-container">
              {facilities.map((facility, index) => (
                <div
                  key={facility.id}
                  className={`facility-slide ${index === currentSlide ? 'active' : ''}`}
                  style={{ backgroundColor: facility.bgColor }}
                >
                  <div className="facility-image">
                      <img src={facility.icon} alt={'Facility Image'}/>
                  </div>
                  <div className="facility-caption">
                    <h3>{facility.name}</h3>
                    <p>{facility.description}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="slider-controls">
              {/*<button
                className="slider-btn prev"
                onClick={() => setCurrentSlide((prev) => (prev - 1 + facilities.length) % facilities.length)}
              >
                <ArrowLeftIcon />
              </button>
              <button
                className="slider-btn next"
                onClick={() => setCurrentSlide((prev) => (prev + 1) % facilities.length)}
              >
                <ArrowRightIcon />
              </button>*/}

                <div className="facility-dots">
                    {facilities.map((_, index) => (
                        <button
                            key={index}
                            className={`dot ${index === currentSlide ? 'active' : ''}`}
                            onClick={() => setCurrentSlide(index)}
                        ></button>
                    ))}
                </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}